import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'inc-abstract-add',
  template: ''
})
export class AbstractAddComponent<T> implements OnInit {
  @Input() form: FormGroup;

  @Input() inData: T;
  @Output() callSave: EventEmitter<T> = new EventEmitter();
  @Output() callUpdate: EventEmitter<T> = new EventEmitter();

  constructor() {
    this.reset();
  }

  ngOnInit() {
    this.discard();
  }

  reset() {
    this.form = this.resetForm();
  }

  discard() {
    if (this.inData) {
      this.form.patchValue(this.inData);
    }
  }

  resetForm() { return null; }

  save(inData: T) {
    this.inData ? this.callUpdate.emit(inData) : this.callSave.emit(inData);
  }
}
